import TextAnimation from '@/components/organisms/textAnimation'
import Container from '@/components/templates/container'
import toPlainText from '@/utils/toPlainText'
import { useInView } from 'react-intersection-observer'

const Info = ({ text }) => {
  const base = 'w-full text-[28px] md:text-[64px] leading-[150%] text-olive font-ttDrugsTrial'
  const { ref, inView } = useInView({
    /* Optional options */
    triggerOnce: true,
  })

  return (
    <Container ref={ref} className="mt-largeMobile lg:mt-largeDesktop">
      <TextAnimation
        inView={inView}
        center
        outerClassName="w-full"
        className={base}
      >
        {toPlainText('secondary',text)}
      </TextAnimation>
    </Container>
  )
}

export default Info
